export const countries = [

	{ "name": "Afghanistan", "name_af": "افغانستان", "value": "AF" },
	{ "name": "Aland Islands", "name_af": "جزیره آیلند", "value": "AX" },
	{ "name": "Albania", "name_af": "آلبانی", "value": "AL" },
	{ "name": "Algeria", "name_af": "الجزایر", "value": "DZ" },
	{ "name": "American Samoa", "name_af": "ساموا امریکای", "value": "AS" },
	{ "name": "Andorra", "name_af": "آندورا", "value": "AD" },
	{ "name": "Angola", "name_af": "آنگولا", "value": "AO" },
	{ "name": "Anguilla", "name_af": "آنگویلا", "value": "AI" },
	{ "name": "Antarctica", "name_af": "آنترکتیکا", "value": "AQ" },
	{ "name": "Antigua and Barbuda", "name_af": "آنتیگوا و باربودا", "value": "AG" },
	{ "name": "Argentina", "name_af": "آرژانتین", "value": "AR" },
	{ "name": "Armenia", "name_af": "ارمنستان", "value": "AM" },
	{ "name": "Aruba", "name_af": "آروبا", "value": "AW" },
	{ "name": "Australia", "name_af": "استرالیا", "value": "AU" },
	{ "name": "Austria", "name_af": "اتریش", "value": "AT" },
	{ "name": "Azerbaijan", "name_af": "آذربایجان", "value": "AZ" },
	{ "name": "Bahamas", "name_af": "باهاما", "value": "BS" },
	{ "name": "Bahrain", "name_af": "بحرین", "value": "BH" },
	{ "name": "Bangladesh", "name_af": "بنگلادش", "value": "BD" },
	{ "name": "Barbados", "name_af": "باربادوس", "value": "BB" },
	{ "name": "Belarus", "name_af": "بلاروس", "value": "BY" },
	{ "name": "Belgium", "name_af": "بلژیک", "value": "BE" },
	{ "name": "Belize", "name_af": "بلیز", "value": "BZ" },
	{ "name": "Benin", "name_af": "بنین", "value": "BJ" },
	{ "name": "Bermuda", "name_af": "برمودا", "value": "BM" },
	{ "name": "Bhutan", "name_af": "پادشاهی بوتان", "value": "BT" },
	{ "name": "Bolivia", "name_af": "بولیوی", "value": "BO" },
	{ "name": "Bonaire, Sint Eustatius and Saba", "name_af": "بوناری، سینت استاتیس و سابا", "value": "BQ" },
	{ "name": "Bosnia and Herzegovina", "name_af": "بوسنی و هرزگوین", "value": "BA" },
	{ "name": "Botswana", "name_af": "بوتسوانا", "value": "BW" },
	{ "name": "Bouvet Island", "name_af": "جزیره بویت", "value": "BV" },
	{ "name": "Brazil", "name_af": "برزیل", "value": "BR" },
	{ "name": "British Indian Ocean Territory", "name_af": "قلم رو دریا انگلیس هند", "value": "IO" },
	{ "name": "Brunei Darussalam", "name_af": "برونئی", "value": "BN" },
	{ "name": "Bulgaria", "name_af": "بلغارستان", "value": "BG" },
	{ "name": "Burkina Faso", "name_af": "بورکینافاسو ", "value": "BF" },
	{ "name": "Burundi", "name_af": "بوروندی", "value": "BI" },
	{ "name": "Cambodia", "name_af": "کامبوج", "value": "KH" },
	{ "name": "Cameroon", "name_af": "کامرون", "value": "CM" },
	{ "name": "Canada", "name_af": "کانادا", "value": "CA" },
	{ "name": "Cape Verde", "name_af": "کیپ ورد", "value": "CV" },
	{ "name": "Cayman Islands", "name_af": "جزیره سایمن", "value": "KY" },
	{ "name": "Central African Republic", "name_af": "جمهوری آفریقای مرکزی", "value": "CF" },
	{ "name": "Chad", "name_af": "چاد", "value": "TD" },
	{ "name": "Chile", "name_af": "شیلی", "value": "CL" },
	{ "name": "China", "name_af": "جمهوری خلق چین", "value": "CN" },
	{ "name": "Christmas Island", "name_af": "جزیره کریسمیس", "value": "CX" },
	{ "name": "Cocos (Keeling} Islands", "name_af": "حزیره کیلینگ", "value": "CC" },
	{ "name": "Colombia", "name_af": "کلمبیا", "value": "CO" },
	{ "name": "Comoros", "name_af": "مجمع‌الجزایر قمر", "value": "KM" },
	{ "name": "Congo", "name_af": "کنگو", "value": "CG" },
	{ "name": "Congo, Democratic Republic of the Congo", "name_af": "جمهوری دموکراتیک کنگو", "value": "CD" },
	{ "name": "Cook Islands", "name_af": "جزیره آشپز", "value": "CK" },
	{ "name": "Costa Rica", "name_af": "کاستاریکا", "value": "CR" },
	{ "name": "Cote D'Ivoire", "name_af": "ساحل عاج", "value": "CI" },
	{ "name": "Croatia", "name_af": "کرواسی", "value": "HR" },
	{ "name": "Cuba", "name_af": "کوبا", "value": "CU" },
	{ "name": "Curacao", "name_af": "کوراکاو", "value": "CW" },
	{ "name": "Cyprus", "name_af": "قبرس", "value": "CY" },
	{ "name": "Czech Republic", "name_af": "جمهوری چک", "value": "CZ" },
	{ "name": "Denmark", "name_af": "دانمارک", "value": "DK" },
	{ "name": "Djibouti", "name_af": "جیبوتی", "value": "DJ" },
	{ "name": "Dominica", "name_af": "دومینیکا", "value": "DM" },
	{ "name": "Dominican Republic", "name_af": "جمهوری دومینیکن", "value": "DO" },
	{ "name": "Ecuador", "name_af": "اکوادور", "value": "EC" },
	{ "name": "Egypt", "name_af": "مصر", "value": "EG" },
	{ "name": "El Salvador", "name_af": "السالوادور", "value": "SV" },
	{ "name": "Equatorial Guinea", "name_af": "گینه استوایی", "value": "GQ" },
	{ "name": "Eritrea", "name_af": "اریتره", "value": "ER" },
	{ "name": "Estonia", "name_af": "استونی", "value": "EE" },
	{ "name": "Ethiopia", "name_af": "اتیوپی", "value": "ET" },
	{ "name": "Falkland Islands (Malvinas}", "name_af": "جزیره مالوینس", "value": "FK" },
	{ "name": "Faroe Islands", "name_af": "جزیره فارو", "value": "FO" },
	{ "name": "Fiji", "name_af": "فیجی", "value": "FJ" },
	{ "name": "Finland", "name_af": "فنلاند", "value": "FI" },
	{ "name": "France", "name_af": "فرانسه", "value": "FR" },
	{ "name": "French Guiana", "name_af": "گویان فرانسه", "value": "GF" },
	{ "name": "French Polynesia", "name_af": "پلینزی فرانسه", "value": "PF" },
	{ "name": "French Southern Territories", "name_af": "سرزمین های جنوبی فرانسه", "value": "TF" },
	{ "name": "Gabon", "name_af": "گابن", "value": "GA" },
	{ "name": "Gambia", "name_af": "گامبیا", "value": "GM" },
	{ "name": "Georgia", "name_af": "گرجستان", "value": "GE" },
	{ "name": "Germany", "name_af": "آلمان", "value": "DE" },
	{ "name": "Ghana", "name_af": "غنا", "value": "GH" },
	{ "name": "Gibraltar", "name_af": "جبل الطارق", "value": "GI" },
	{ "name": "Greece", "name_af": "یونان", "value": "GR" },
	{ "name": "Greenland", "name_af": "گرینلند", "value": "GL" },
	{ "name": "Grenada", "name_af": "گرانادا", "value": "GD" },
	{ "name": "Guadeloupe", "name_af": "گوادلوپ", "value": "GP" },
	{ "name": "Guam", "name_af": "گوام", "value": "GU" },
	{ "name": "Guatemala", "name_af": "گواتمالا", "value": "GT" },
	{ "name": "Guernsey", "name_af": "گرنزی", "value": "GG" },
	{ "name": "Guinea", "name_af": "گینه", "value": "GN" },
	{ "name": "Guinea-Bissau", "name_af": "گینه بیسائو", "value": "GW" },
	{ "name": "Guyana", "name_af": "گویان", "value": "GY" },
	{ "name": "Haiti", "name_af": "هائیتی", "value": "HT" },
	{ "name": "Honduras", "name_af": "هندوراس", "value": "HN" },
	{ "name": "Hungary", "name_af": "مجارستان", "value": "HU" },
	{ "name": "Iceland", "name_af": "ایسلند", "value": "IS" },
	{ "name": "India", "name_af": "هندوستان", "value": "IN" },
	{ "name": "Indonesia", "name_af": "اندونزی", "value": "ID" },
	{ "name": "Iran, Islamic Republic of", "name_af": "ایران", "value": "IR" },
	{ "name": "Iraq", "name_af": "عراق", "value": "IQ" },
	{ "name": "Ireland", "name_af": "ایرلند", "value": "IE" },
	{ "name": "Israel", "name_af": "اسرائیل", "value": "IL" },
	{ "name": "Italy", "name_af": "ایتالیا", "value": "IT" },
	{ "name": "Jamaica", "name_af": "جامائیکا", "value": "JM" },
	{ "name": "Japan", "name_af": "ژاپن", "value": "JP" },
	{ "name": "Jordan", "name_af": "اردن", "value": "JO" },
	{ "name": "Kazakhstan", "name_af": "قزاقستان", "value": "KZ" },
	{ "name": "Kenya", "name_af": "کنیا", "value": "KE" },
	{ "name": "Kiribati", "name_af": "کیریباتی", "value": "KI" },
	{ "name": "Kosovo", "name_af": "کوزوو", "value": "XK" },
	{ "name": "Kuwait", "name_af": "کویت", "value": "KW" },
	{ "name": "Kyrgyzstan", "name_af": "قرقیزستان", "value": "KG" },
	{ "name": "Lao People's Democratic Republic", "name_af": "لائوس", "value": "LA" },
	{ "name": "Latvia", "name_af": "لتونی", "value": "LV" },
	{ "name": "Lebanon", "name_af": "لبنان", "value": "LB" },
	{ "name": "Lesotho", "name_af": "لسوتو", "value": "LS" },
	{ "name": "Liberia", "name_af": "لیبریا", "value": "LR" },
	{ "name": "Libyan Arab Jamahiriya", "name_af": "لیبی", "value": "LY" },
	{ "name": "Liechtenstein", "name_af": "لیختن اشتاین", "value": "LI" },
	{ "name": "Lithuania", "name_af": "لیتوانی", "value": "LT" },
	{ "name": "Luxembourg", "name_af": "لوکزامبورگ", "value": "LU" },
	{ "name": "Macao", "name_af": "ماکاو", "value": "MO" },
	{ "name": "Madagascar", "name_af": "ماداگاسکار", "value": "MG" },
	{ "name": "Malawi", "name_af": "مالاوی", "value": "MW" },
	{ "name": "Malaysia", "name_af": "مالزی", "value": "MY" },
	{ "name": "Maldives", "name_af": "مالدیو", "value": "MV" },
	{ "name": "Mali", "name_af": "مالی", "value": "ML" },
	{ "name": "Malta", "name_af": "مالت", "value": "MT" },
	{ "name": "Marshall Islands", "name_af": "جزایر مارشال", "value": "MH" },
	{ "name": "Martinique", "name_af": "مارتینیک", "value": "MQ" },
	{ "name": "Mauritania", "name_af": "موریتانی", "value": "MR" },
	{ "name": "Mauritius", "name_af": "موریس", "value": "MU" },
	{ "name": "Mexico", "name_af": "مکزیک", "value": "MX" },
	{ "name": "Micronesia, Federated States of", "name_af": "میکرونزی", "value": "FM" },
	{ "name": "Moldova, Republic of", "name_af": "مولدووا", "value": "MD" },
	{ "name": "Monaco", "name_af": "موناکو", "value": "MC" },
	{ "name": "Mongolia", "name_af": "مغولستان", "value": "MN" },
	{ "name": "Montenegro", "name_af": "مونته‌نگرو", "value": "ME" },
	{ "name": "Montserrat", "name_af": "مونتسرات", "value": "MS" },
	{ "name": "Morocco", "name_af": "مراکش", "value": "MA" },
	{ "name": "Mozambique", "name_af": "موزامبیک", "value": "MZ" },
	{ "name": "Myanmar", "name_af": "میانمار", "value": "MM" },
	{ "name": "Namibia", "name_af": "نامیبیا", "value": "NA" },
	{ "name": "Nauru", "name_af": "نائورو", "value": "NR" },
	{ "name": "Nepal", "name_af": "نپال", "value": "NP" },
	{ "name": "Netherlands", "name_af": "هلند", "value": "NL" },
	{ "name": "New Zealand", "name_af": "نیوزیلند", "value": "NZ" },
	{ "name": "Nicaragua", "name_af": "نیکاراگوئه", "value": "NI" },
	{ "name": "Niger", "name_af": "نیجر", "value": "NE" },
	{ "name": "Nigeria", "name_af": "نیجریه", "value": "NG" },
	{ "name": "Noth Korea", "name_af": "کره شمالی", "value": "KP" },
	{ "name": "Norway", "name_af": "نروژ", "value": "NO" },
	{ "name": "Oman", "name_af": "عمان", "value": "OM" },
	{ "name": "Pakistan", "name_af": "پاکستان", "value": "PK" },
	{ "name": "Palau", "name_af": "پالائو", "value": "PW" },
	{ "name": "Palestinian Territory, Occupied", "name_af": "فلسطین", "value": "PS" },
	{ "name": "Panama", "name_af": "پاناما", "value": "PA" },
	{ "name": "Papua New Guinea", "name_af": "پاپوآ گینه نو", "value": "PG" },
	{ "name": "Paraguay", "name_af": "پاراگوئه", "value": "PY" },
	{ "name": "Peru", "name_af": "پرو", "value": "PE" },
	{ "name": "Philippines", "name_af": "فیلیپین", "value": "PH" },
	{ "name": "Pitcairn", "name_af": "پیتکرن", "value": "PN" },
	{ "name": "Poland", "name_af": "لهستان", "value": "PL" },
	{ "name": "Portugal", "name_af": "پرتغال", "value": "PT" },
	{ "name": "Puerto Rico", "name_af": "پورتوریکو", "value": "PR" },
	{ "name": "Qatar", "name_af": "قطر", "value": "QA" },
	{ "name": "Romania", "name_af": "رومانی", "value": "RO" },
	{ "name": "Russian Federation", "name_af": "روسیه", "value": "RU" },
	{ "name": "Rwanda", "name_af": "رواندا", "value": "RW" },
	{ "name": "Saint Kitts and Nevis", "name_af": "سنت کیتس و نویس", "value": "KN" },
	{ "name": "Saint Lucia", "name_af": "سنت لوسیا", "value": "LC" },
	{ "name": "Saint Vincent and the Grenadines", "name_af": "سنت وینسنت و گرنادین‌ها", "value": "VC" },
	{ "name": "Samoa", "name_af": "ساموآ", "value": "WS" },
	{ "name": "San Marino", "name_af": "سن مارینو", "value": "SM" },
	{ "name": "Sao Tome and Principe", "name_af": "سائوتومه و پرینسیپ", "value": "ST" },
	{ "name": "Saudi Arabia", "name_af": "عربستان سعودی", "value": "SA" },
	{ "name": "Senegal", "name_af": "سنگال", "value": "SN" },
	{ "name": "Serbia", "name_af": "صربستان", "value": "RS" },
	{ "name": "Seychelles", "name_af": "سیشل", "value": "SC" },
	{ "name": "Sierra Leone", "name_af": "سیرالئون", "value": "SL" },
	{ "name": "Singapore", "name_af": "سنگاپور", "value": "SG" },
	{ "name": "Slovakia", "name_af": "اسلواکی", "value": "SK" },
	{ "name": "Slovenia", "name_af": "اسلوونی", "value": "SI" },
	{ "name": "Solomon Islands", "name_af": "جزایر سلیمان", "value": "SB" },
	{ "name": "Somalia", "name_af": "سومالی", "value": "SO" },
	{ "name": "South Africa", "name_af": "آفریقای جنوبی", "value": "ZA" },
	{ "name": "South Korea", "name_af": "کره جنوبی", "value": "KR" },
	{ "name": "South Sudan", "name_af": "سودان جنوبی", "value": "SS" },
	{ "name": "Spain", "name_af": "اسپانیا", "value": "ES" },
	{ "name": "Sri Lanka", "name_af": "سری‌لانکا", "value": "LK" },
	{ "name": "Sudan", "name_af": "سودان", "value": "SD" },
	{ "name": "Suriname", "name_af": "سورینام", "value": "SR" },
	{ "name": "Swaziland", "name_af": "سوازیلند", "value": "SZ" },
	{ "name": "Sweden", "name_af": "سوئد", "value": "SE" },
	{ "name": "Switzerland", "name_af": "سوئیس", "value": "CH" },
	{ "name": "Syrian Arab Republic", "name_af": "سوریه", "value": "SY" },
	{ "name": "Taiwan, Province of China", "name_af": "تایوان", "value": "TW" },
	{ "name": "Tajikistan", "name_af": "تاجیکستان", "value": "TJ" },
	{ "name": "Tanzania, United Republic of", "name_af": "تانزانیا", "value": "TZ" },
	{ "name": "Thailand", "name_af": "تایلند", "value": "TH" },
	{ "name": "Togo", "name_af": "توگو", "value": "TG" },
	{ "name": "Tonga", "name_af": "تونگا", "value": "TO" },
	{ "name": "Trinidad and Tobago", "name_af": "ترینیداد و توباگو", "value": "TT" },
	{ "name": "Tunisia", "name_af": "تونس", "value": "TN" },
	{ "name": "Turkey", "name_af": "ترکیه", "value": "TR" },
	{ "name": "Turkmenistan", "name_af": "ترکمنستان", "value": "TM" },
	{ "name": "Tuvalu", "name_af": "تووالو", "value": "TV" },
	{ "name": "Uganda", "name_af": "اوگاندا", "value": "UG" },
	{ "name": "Ukraine", "name_af": "اوکراین", "value": "UA" },
	{ "name": "United Arab Emirates", "name_af": "امارات متحده عربی", "value": "AE" },
	{ "name": "United Kingdom", "name_af": "انگلستان", "value": "GB" },
	{ "name": "United States of America", "name_af": "ایالات متحده آمریکا", "value": "US" },
	{ "name": "Uruguay", "name_af": "اروگوئه", "value": "UY" },
	{ "name": "Uzbekistan", "name_af": "ازبکستان", "value": "UZ" },
	{ "name": "Vanuatu", "name_af": "وانواتو", "value": "VU" },
	{ "name": "Venezuela", "name_af": "ونزوئلا", "value": "VE" },
	{ "name": "Viet Nam", "name_af": "ویتنام", "value": "VN" },
	{ "name": "Yemen", "name_af": "یمن", "value": "YE" },
	{ "name": "Zambia", "name_af": "زامبیا", "value": "ZM" },
	{ "name": "Zimbabwe", "name_af": "زیمبابوه", "value": "ZW" }
];

export const setCountries = () => {
	return countries?.map((c, i) => {
		c.label = c?.name + " - " + c?.name_af;
		return c;
	})


}





